const key = 'fis_tarihce';

export const saveHistory = (FisNo, data) => {
  try {
    const historyObj = {
      FisNo,
      DATE: new Date(),
      DATA: data
    };
    let historyAll = loadHistoryAll();
    historyAll = [...historyAll, historyObj];
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(historyAll));
  } catch (error) {}
};

// Fişe ait tarihçeyi kontrol edr
export const loadHistory = FisNo => {
  try {
    const historyAll = loadHistoryAll();
    const filtered = historyAll.filter(
      h => parseInt(h.FisNo) === parseInt(FisNo)
    );
    if (filtered.length === 0) {
      // localde yok. Return empty.
      return [];
    }
    if (filtered.length > 1) {
      removeHistory(FisNo);
      return [];
    }
    const history = filtered[0];
    const now = new Date();
    const ld = new Date(history.DATE); // Last Date
    if (
      now.getYear() === ld.getYear() &&
      now.getMonth() === ld.getMonth() &&
      now.getDate() === ld.getDate()
    ) {
      return history.DATA;
    }
    removeHistory(FisNo);
    return [];
  } catch (error) {
    return [];
  }
};

// /////////// HELPER METHODS (NOT EXPORTED) /////////////////////

// localstorage'daki tüm history leri getirir.
const loadHistoryAll = () => {
  try {
    let historyTxt = localStorage.getItem(key);
    if (historyTxt === null) {
      localStorage.setItem(key, '[]');
      historyTxt = '[]';
    }
    return JSON.parse(historyTxt);
  } catch (error) {
    return [];
  }
};

const removeHistory = FisNo => {
  try {
    const historyAll = loadHistoryAll();
    const otherHistory = historyAll.filter(
      h => parseInt(h.FisNo) !== parseInt(FisNo)
    );
    localStorage.setItem(key, JSON.stringify(otherHistory));
    return true;
  } catch (error) {
    return false;
  }
};
